import { SelectedBenchmark } from '../../../shared/constants/filter/filter';
import { ConfigDataType } from '../../../shared/types/filters';
import { IndustryStandardType } from './constants';

export const getIndustryStandardFilterLabel = (
  configData: ConfigDataType | undefined,
  benchmarkType: SelectedBenchmark,
) => {
  const industry = configData?.industries.find((industry) => {
    return industry.id === benchmarkType;
  });

  if (industry?.meta.type === IndustryStandardType.SECTOR) {
    return `Industry: ${industry?.name}`;
  }

  if (industry?.meta.type === IndustryStandardType.SIZE) {
    return `Size: ${industry?.name}`;
  }

  return `Industry: Average Industries`;
};
